<template>
  <div class="awards" v-if="AwardHomeData">
    <HeadBlock />

    <div class="carousel_box" v-if="carouselItems">
      <div>
        <VueSlickCarousel :arrows="true" :dots="true">
          <div class="img_box" v-for="(carousel, carouselIndex) in carouselItems" :key="carouselIndex">
            <img :src="carousel.Src" :alt="carousel.title">
          </div>
        </VueSlickCarousel>
      </div>
    </div>

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <div class="container">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('金曲獎') }}</li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('頒獎典禮') }}</li>
        </div>
      </ol>
    </nav>
    <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
      :::
    </a>
    <!-- 內容 -->
    <div class="main">
      <div class="container" v-if="AwardHomeData.Awards_Text" v-html="AwardHomeData.Awards_Text">
      </div>
    </div>
    <FooterBlock />
  </div>
</template>
<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
    "頒獎典禮": "頒獎典禮",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
    "頒獎典禮": "Award Ceremony",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "AwardHome",
  i18n,
  components: {
    Slick,
    HeadBlock,
    FooterBlock,
    VueSlickCarousel,
  },
  data() {
    return {
      AwardHomeData: {},
      carouselItems: null,
      local: "zh_tw",
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/AwardHome",
    //     {
    //       params: {
    //         lang: $cookies.get("gma_the_site_lang")
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.AwardHomeData = response.data;
    //     this.carouselItems = this.AwardHomeData.carouselItems;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });    
    if ($cookies.get("gma_the_site_lang") == "zh_tw") {
      this.AwardHomeData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "carouselItems": [
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/4c2c5bab-1bae-436b-8ea3-371949880e2a.webp",
            "title": "Banner(4)"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/e1013f66-9f77-4e9a-a11b-11477c56a105.webp",
            "title": "Banner(3)"
          }
        ],
        "Awards_Text": "<h2>舉辦時間 / 地點</h2>\n\n<div class=\"text\">\n<div class=\"time\">\n<p>星光大道</p>\n\n<p>2025/06/28（六）17：00 臺北小巨蛋 南廣場</p>\n</div>\n\n<div class=\"time\">\n<p>頒獎典禮</p>\n\n<p>2025/06/28（六）19：00 臺北小巨蛋</p>\n</div>\n</div>\n\n<hr class=\"line\" />\n<h2>『2025第36屆金曲獎』播出訊息</h2>\n\n<div class=\"text table_box table_box_1\">\n<table border=\"1\" class=\"list broadcast-table\">\n\t<caption>『2025第36屆金曲獎』播出訊息</caption>\n\t<thead>\n\t\t<tr class=\"title\">\n\t\t\t<th scope=\"col\">地區</th>\n\t\t\t<th scope=\"col\">頻道</th>\n\t\t\t<th scope=\"col\">方式</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td class=\"center\" data-date=\"地區\">臺灣</td>\n\t\t\t<td data-date=\"頻道\">\n\t\t\t<p>臺灣電視台、MOD</p>\n\n\t\t\t<p>LINE TODAY（多視角服務）、LINE MUSIC</p>\n\n\t\t\t<p>台視綜合台、非凡新聞台、非凡商業台</p>\n\t\t\t</td>\n\t\t\t<td data-date=\"方式\">\n\t\t\t<p>直播+重播</p>\n\n\t\t\t<p>直播</p>\n\n\t\t\t<p>重播</p>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td data-date=\"地區\">全球</td>\n\t\t\t<td data-date=\"頻道\">金曲YouTube頻道（多視角服務）</td>\n\t\t\t<td data-date=\"方式\">直播+重播</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td data-date=\"地區\">新加坡</td>\n\t\t\t<td data-date=\"頻道\">StarHub「HUB都會台」</td>\n\t\t\t<td data-date=\"方式\">直播+重播</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td data-date=\"地區\">馬來西亞、汶萊</td>\n\t\t\t<td data-date=\"頻道\">Astro</td>\n\t\t\t<td data-date=\"方式\">直播+重播</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td data-date=\"地區\">馬來西亞</td>\n\t\t\t<td data-date=\"頻道\">sooka</td>\n\t\t\t<td data-date=\"方式\">直播+重播</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td class=\"center\" data-date=\"地區\">北美（美、加）</td>\n\t\t\t<td class=\"aa\" data-date=\"頻道\">\n\t\t\t<p>台視美洲頻道</p>\n\n\t\t\t<p>iTalkBB</p>\n\n\t\t\t<p>Dish Network 衛星電視</p>\n\n\t\t\t<p>Sling TV</p>\n\t\t\t</td>\n\t\t\t<td class=\"center\" data-date=\"方式\">重播</td>\n\t\t</tr>\n\t</tbody>\n</table>\n</div>\n"
      };
    } else {
      this.AwardHomeData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "carouselItems": [
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/06d7399c-f4fa-489d-b6f7-8394e960af9e.webp",
            "title": "Banner(3)"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/039ca1af-c7ed-4fa5-b934-ee281782221c.webp",
            "title": "Banner(3)"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/75f07901-cdb3-443f-987c-9121783275ff.webp",
            "title": "Banner(2)"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/cbd7c0d0-7319-4181-9876-11604e34c53b.webp",
            "title": "Banner(2)"
          }
        ],
        "Awards_Text": "<h2>Time / Location</h2>\n\n<div class=\"text\">\n<div class=\"time\">\n<p>Red Carpet</p>\n\n<p>2025/06/28 Sat. 17:00 Taipei Arena &ndash; Southern Plaza</p>\n</div>\n\n<div class=\"time\">\n<p>Awards Ceremony</p>\n\n<p>2025/06/28 Sat. 19:00 Taipei Arena</p>\n</div>\n</div>\n\n<hr class=\"line\" />\n<h2>Broadcast Information</h2>\n\n<div class=\"text\">\n<ul class=\"list\">\n\t<li class=\"title\">\n\t<div>\n\t<p>Location</p>\n\t</div>\n\n\t<div>\n\t<p>Channel</p>\n\t</div>\n\n\t<div>\n\t<p>Status</p>\n\t</div>\n\t</li>\n\t<li>\n\t<div class=\"center\" data-date=\"Region\">\n\t<p>Taiwan</p>\n\t</div>\n\n\t<div data-date=\"Channel\">\n\t<p>Taiwan Television (TTV), MOD</p>\n\n\t<p>LINE TODAY (Multi-angle service), LINE MUSIC</p>\n\n\t<p>TTV Variety, USTV News, USTV Business</p>\n\t</div>\n\n\t<div data-date=\"Type\">\n\t<p>Live + Rerun</p>\n\n\t<p>Live</p>\n\n\t<p>Rerun</p>\n\t</div>\n\t</li>\n\t<li>\n\t<div data-date=\"Region\">\n\t<p>Global</p>\n\t</div>\n\n\t<div data-date=\"Channel\">\n\t<p>YouTube-GMA (Multi-angle service)</p>\n\t</div>\n\n\t<div data-date=\"Type\">\n\t<p>Live + Rerun</p>\n\t</div>\n\t</li>\n\t<li>\n\t<div data-date=\"Region\">\n\t<p>Singapore</p>\n\t</div>\n\n\t<div data-date=\"Channel\">\n\t<p>StarHub &ldquo;HUB&rdquo;</p>\n\t</div>\n\n\t<div data-date=\"Type\">\n\t<p>Live + Rerun</p>\n\t</div>\n\t</li>\n\t<li>\n\t<div data-date=\"Region\">\n\t<p>Malaysia, Brunei</p>\n\t</div>\n\n\t<div data-date=\"Channel\">\n\t<p>Astro</p>\n\t</div>\n\n\t<div data-date=\"Type\">\n\t<p>Live + Rerun</p>\n\t</div>\n\t</li>\n\t<li>\n\t<div data-date=\"Region\">\n\t<p>Malaysia</p>\n\t</div>\n\n\t<div data-date=\"Channel\">\n\t<p>sooka</p>\n\t</div>\n\n\t<div data-date=\"Type\">\n\t<p>Live + Rerun</p>\n\t</div>\n\t</li>\n\t<li>\n\t<div class=\"center\" data-date=\"Region\">\n\t<p>North America (US and Canada)</p>\n\t</div>\n\n\t<div class=\"aa\" data-date=\"Channel\">\n\t<p>TTV America Channel</p>\n\n\t<div>\n\t<p>iTalkBB</p>\n\n\t<p>Dish Network</p>\n\n\t<p>Sling TV</p>\n\t</div>\n\t</div>\n\n\t<div class=\"center\" data-date=\"Type\">\n\t<p>Rerun</p>\n\t</div>\n\t</li>\n</ul>\n\n<p class=\"notice\">Broadcast Information for the 36th Golden Melody Awards in 2025</p>\n</div>\n"
      };
    }
    this.carouselItems = this.AwardHomeData.carouselItems;
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
  },
};
</script>